export function get_color_rgb(name) {
  if ( name && name.startsWith('#') ) {
    return name; /* name is already a rgb code */
  }
  switch ( name ) {
    case 'blue':      return '#467fcf';
    case 'indigo':    return '#6574cd';
    case 'purple':    return '#a55eea';
    case 'pink':      return '#f66d9b';
    case 'red':       return '#cd201f';
    case 'orange':    return '#fd9644';
    case 'yellow':    return '#f1c40f';
    case 'green':     return '#5eba00';
    case 'teal':      return '#2bcbba';
    case 'cyan':      return '#17a2b8';
    case 'white':     return '#ffffff';
    case 'gray':      return '#868e96';
    case 'gray-dark': return '#343a40';
    case 'azure':     return '#45aaf2';
    case 'lime':      return '#7bd235';
    case 'primary':   return '#467fcf';
    case 'secondary': return '#868e96';
    case 'success':   return '#5eba00';
    case 'info':      return '#45aaf2';
    case 'warning':   return '#f1c40f';
    case 'danger':    return '#cd201f';
    case 'light':     return '#f8f9fa';
    case 'dark':      return '#343a40';
    case 'default':   return '#d0d0d6'; // rgb(203, 232, 107)
    default:          return '#000000';
  }
}

// eslint-disable-next-line
const MINIMAL_COLORS = [
  '#ff4500',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585',
];

// eslint-disable-next-line
const DEFAULT_LOGO_COLORS = [
  'azure',
  'indigo',
  'purple',
  'pink',
  'red',
  'orange',
  'yellow',
  'lime',
  'green',
  'teal'
]

const GRIDAPPS_LOGO_COLORS = [
  '#56a7b2', /* Color from gridapps logo */
  '#63c3d1',
  '#009f3c',
  '#34a936',
  '#69b42d',
  '#8fbf21',
  '#f9ae00',
  '#f28d00',
  '#ed6b06',
  '#e74310',
  '#e30613',
  '#aa1816',
  '#17abe3',
  '#0092d2',
  '#1d3e8a',
  '#243579',
  '#5b1646',
  '#40182f',
  '#EEEEEE',
  '#FFFFFF',
];

export const COLOR_LIST = GRIDAPPS_LOGO_COLORS;
